export const environment = {
  production: false,
  environment: 'development',
  workflowApiUrl: 'https://dev.back.pre-credit.com/api/workflow/v1/web',
  coreApiUrl: 'https://dev.back.pre-credit.com/api/core/v1/web',
  brandingCacheTtlMs: 60000,
  idleTimeoutMs: 1800000,
  maxSessionMs: 28800000,
};
